import ListItem, {
    type Props as ListItemProps,
} from 'js/components/ListItem/ListItem'
import cx from 'js/lib/helpers/cx'

import styles from './Link.module.css'

/**
 * @todo TODO: the size override is not a good idea. get rid of it and use the
 * `ListItem` component instead.
 */
type LinkProps = Omit<ListItemProps, '$size'> & {
    $size?: 'small' | 'normal'
}

/**
 * @todo TODO: this is not a good composition. get rid of the class name
 * manipulation and use the `ListItem` component instead.
 */
const Link = ({ $size, className, ...rest }: LinkProps) => (
    <ListItem
        // TODO: stop using the $-prefixes
        size={$size}
        // TODO: stop using the class name manipulation.
        className={cx(
            styles.link,
            $size === 'small' && styles.sizeSmall,
            $size === 'normal' && styles.sizeNormal,
            className,
        )}
        {...rest}
    />
)

export default Link
